import { Link } from 'react-router-dom';
import { useState } from 'react';
import umdlogo from '../assets/images/umdlogo.png';
import logo from '../assets/images/Q3LOGO_notext.png';
import '../styles/qreate.css';
import oshiro from "../assets/images/speakers/oshiro.png";
import danielserrano from "../assets/images/speakers/danielserrano.png";
import benally from "../assets/images/speakers/benally.png";
import bruce from "../assets/images/speakers/bruce.jpg";
import halpern from "../assets/images/speakers/nicolehalpern.png";
import amelie from "../assets/images/speakers/amelie.jpg";
import myungin from "../assets/images/speakers/myungin.jpg";
import jonathan from "../assets/images/speakers/jonathan.JPG";
import alexander from "../assets/images/speakers/alexander.jpg";
import lucy from "../assets/images/speakers/lucy.png";
import adriane from "../assets/images/speakers/adriane.jpg";
import carl from "../assets/images/speakers/carl.png";
import eric from "../assets/images/speakers/eric.png";
import marcello from "../assets/images/speakers/marcello.jpeg";
import jonathanmartin from "../assets/images/speakers/jonathanmartin.jpeg";

function Qreate() {
  
  const slides = [
    {
      title: 'Keynotes & Talks',
      items: [
        'Alexander Golob',
        'Myungin Lee',
        'Scott Oshiro',
        'Nicole Yunger Halpern',
        'Bruce Modvic',
      ],
    },
    {
      title: 'Creative Workshops',
      items: [
        'Illustration/Comic Making',
        'Animating Quantum Chips on Blender',
        'Animations with Manim',
      ],
    },
    {
      title: 'Exhibitions & Performances',
      items: [
        'LiteraryDJ Quantum Poetry',
        'Quantum Intuition',
        'Quantum Choreographics',
        'Science & Music of the Bloch Sphere',
        'Quantum Steampunk Engine',
      ],
    },
  ];

  const [index, setIndex] = useState(0);
  const prev = () => setIndex((index - 1 + slides.length) % slides.length);
  const next = () => setIndex((index + 1) % slides.length); 

  return (
    <>
    <section className="intro-section">
      <div className="intro-content">
        <div className="left">
        <h1 className="title">
          <span>Q<sup>3</sup> Initiative:</span><br/>
          <span>QREATE @ UMD</span>
          </h1>

          <p className="paragraph">
            Q<sup>3</sup> is a joint quantum initiative between the University of Maryland, College Park
            and the University of Southern California dedicated to uniting quantum science with diverse fields such as art, policy, and economics to inspire, educate, and develop quantum technologies for the public good.
            The goal of Q<sup>3</sup> is to create more quantum-related educational tools, provide learning and
            networking opportunities, and teach engineers more about the economics and policy of emerging quantum technologies.
          </p>
        </div>

        <div className="right">
          <img src={logo} alt="Q3 Logo" className="logo" />
        </div>
      </div>

      <div className="date-box">
        September 12, 2025 – September 13, 2025 | University of Maryland, College Park Stamp Student Union
      </div>
    </section>

    <section className="umd-section">
      <div className="umd-overlay"/>
      <img src={umdlogo} alt="UMD logo" className="umd-logo"/>
      <div className="intro-section umd-content" >
      <h2 className="umd-heading">Q<sup>3</sup> @ UMD</h2>
      <p className='paragraph'style={{ color: 'white', textAlign: 'left' }}>At UMD, Q<sup>3</sup> will explore the intersection of quantum science and the arts. Through creative workshops, keynote talks by scientists and artists, exhibitions of quantum art, and virtual challenges, the program aims to make complex quantum concepts more accessible to the public. Our goal is to create an open, growing collection of educational quantum materials and to foster a community of students skilled in communicating complex scientific ideas to diverse audiences—making quantum science accessible to all. </p>
      </div>
    </section>

    <section className="speakers-section">
      <div className="speakers-header-box">
        <h2 className="title">Our Speakers</h2>
      </div>
      <div className="cards-container">
        <Link to="/oshiro" className="speaker-card">
          <img src={oshiro} alt="Scott Oshiro" className="speakerspic"/>
          <div className="speaker-info">
            <h3>Scott Oshiro</h3>
          </div>
        </Link>

        <Link to="/alexander" className="speaker-card">
          <img src={alexander} alt="Alexander Golob" className="speakerspic"/>
          <div className="speaker-info">
            <h3>Alexander Golob</h3>
          </div>
        </Link>

         <Link to="/halpern" className="speaker-card">
          <img src={halpern} alt="Nicole Yunger Halpern" className="speakerspic"/>
          <div className="speaker-info">
            <h3>Nicole Yunger Halpern</h3>
          </div>
        </Link>

         <Link to="/bruce" className="speaker-card">
          <img src={bruce} alt="Bruce Rosenbaum" className="speakerspic"/>
          <div className="speaker-info">
            <h3>Bruce Rosenbaum</h3>
          </div>
        </Link>

          <Link to="/myungin" className="speaker-card">
              <img src={myungin} alt="Myungin Lee" className="speakerspic"/>
              <div className="speaker-info">
                  <h3>Myungin Lee</h3>
              </div>
          </Link>

            <Link to="/serrano" className="speaker-card">
          <img src={danielserrano} alt="Daniel Serrano" className="speakerspic"/>
          <div className="speaker-info">
            <h3>Daniel Serrano</h3>
          </div>
        </Link>

        <Link to="/benally" className="speaker-card">
          <img src={benally} alt="Onri Jay Benally" className="speakerspic"/>
          <div className="speaker-info">
            <h3>Onri Benally</h3>
          </div>
        </Link>

          <Link to="/amelie" className="speaker-card">
              <img src={amelie} alt="Amelie Wang" className="speakerspic"/>
              <div className="speaker-info">
                  <h3>Amelie Wang</h3>
              </div>
          </Link>

          <Link to="/jonathan" className="speaker-card">
              <img src={jonathan} alt="Jonathan Waldorf" className="speakerspic"/>
              <div className="speaker-info">
                  <h3>Jonathan Waldorf</h3>
              </div>
          </Link>
      </div>
    </section>

        <section className="speakers-section" >
      <div className="speakers-header-box" >
        <h2 className="title">Our Performers</h2>
      </div>
      <div className="cards-container">
        <Link to="/lucy" className="speaker-card">
          <img src={lucy} alt="Lucy Liuxuan Zhang" className="speakerspic"/>
          <div className="speaker-info">
            <h3>Lucy Liuxuan Zhang</h3>
          </div>
        </Link>

        <div className="speaker-card">
          <img src={adriane} alt="Adriane Fang" className="speakerspic"/>
          <div className="speaker-info">
            <h3>Adriane Fang</h3>
          </div>
        </div>

        <div className="speaker-card">
          <img src={carl} alt="Carl Miller" className="speakerspic"/>
          <div className="speaker-info">
            <h3>Carl A. Miller</h3>
          </div>
        </div>

        <Link to="/eric" className="speaker-card">
          <img src={eric} alt="Eric Huang" className="speakerspic"/>
          <div className="speaker-info">
            <h3>Eric Huang</h3>
          </div>
        </Link>

        <Link to="/marcello" className="speaker-card">
          <img src={marcello} alt="Marcello Silva" className="speakerspic"/>
          <div className="speaker-info">
            <h3>Marcello Silva</h3>
          </div>
        </Link>

        <Link to="/jonathanmartin" className="speaker-card">
          <img src={jonathanmartin} alt="Jonathan Martin" className="speakerspic"/>
          <div className="speaker-info">
            <h3>Jonathan Martin</h3>
          </div>
        </Link>


      </div>
    </section>
    
    <section className="activities-section">
      <div className="speakers-header-box">
        <h2 className="title" style={{fontSize:'3rem'}}>{slides[index].title}</h2>
      </div>
      <div className="slider-container">
        <div
          className="slider-content"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {slides.map((slide) => (
            <div className="slider-slide" key={slide.title}>
              <ul>
                {slide.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="slider-navigation">
        <button onClick={prev} className="slider-arrow">←</button>
        <div className="dot-nav">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              className={`dot ${i === index ? 'active' : ''}`}
            />
          ))}
        </div>
        <button onClick={next} className="slider-arrow">→</button>
      </div>
    </section>


        <section className="challenges-showcase" style={{ padding: '3rem 2rem' }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                {/* Challenge Title */}
                <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                    <h2 style={{ fontSize: '3rem', color: '#2c5282', fontWeight: '600' }}>Challenges</h2>
                </div>

                {/* Challenge Description Box */}
                <Link to="/cqn" style={{ textDecoration: 'none' }}>

                    <div className="challenge-card">
                        <h3 style={{ fontSize: '2rem', color: '#2c5282', fontWeight: '600', marginBottom: '1rem' }}>
                            <Link to="/cqn" style={{ color: '#2c5282', textDecoration: 'none' }}>
                                CQN Challenges
                            </Link>
                        </h3>
                        <p>
                            The Center for Quantum Networks (CQN) seeks student-led demos and proposals for projects designed to teach quantum information science and engineering (QISE) concepts to non-technical and semi-technical audiences.
                        </p>
                        <div className="challenge-box">

                            <div style={{ textAlign: 'center' }}>
                                <strong style={{ color: '#2c5282', fontSize: '1.3rem' }}>9/13 - 10/10</strong>
                                <p style={{ color: '#718096', marginTop: '0.5rem' }}>hacking period</p>
                            </div>
                            <div style={{ textAlign: 'center' }}>
                                <strong style={{ color: '#2c5282', fontSize: '1.3rem' }}>1-4 people</strong>
                                <p style={{ color: '#718096', marginTop: '0.5rem' }}>team size</p>
                            </div>
                            <div style={{ textAlign: 'center' }}>
                                <strong style={{ color: '#2c5282', fontSize: '1.3rem' }}>1-2 semesters</strong>
                                <p style={{ color: '#718096', marginTop: '0.5rem' }}>duration of funding</p>
                            </div>
                            <div style={{ textAlign: 'center' }}>
                                <strong style={{ color: '#2c5282', fontSize: '1.3rem' }}>5 pages</strong>
                                <p style={{ color: '#718096', marginTop: '0.5rem' }}>proposal limit</p>
                            </div>
                            <div style={{ textAlign: 'center' }}>
                                <strong style={{ color: '#2c5282', fontSize: '1.3rem' }}>$10,000</strong>
                                <p style={{ color: '#718096', marginTop: '0.5rem' }}>per project</p>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
        </section>

      <section className="umd-section">
      <div className="schedule-container">
        <div className="schedule-left">
          <p className="schedule-label">EVENT / TIME</p>
          <p className="schedule-time">FRIDAY – SATURDAY</p>
        </div>
        <div className="schedule-right">
          <h2 className="schedule-title">SCHEDULE</h2>
          <Link to="/Schedule" className="btn">→</Link> 
        </div>
      </div>
    </section>

    <section className="intro-section">
    <div className="intro-content">
    <div className="left">
        <h1 className="title" style={{textAlign: 'center'}}>
          <span>Q<sup>3</sup> @ USC</span>
          </h1>
          <p className="paragraph">
            Engage in more technical quantum challenges from IBM Quantum.
          </p>
        </div>
        <div className="right" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flex: '0 0 auto'}}>
          <Link to="/Qethics" className="btn" style={{fontWeight: 400 }}>Quantum Leap to the West Coast→</Link>
        </div>
    </div>
    </section>

  </>
  );
}

export default Qreate;
